import template from './sale-type.jade';
import saleType from '../../../enums/sale-type';
import validation from './../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.saleType', []).directive('cianAfPriceAndDealTermsSaleType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(isSimpleFormEnabled, deviceService, store) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.saleTypes = saleType;
    this.isSimpleFormEnabled = isSimpleFormEnabled;

    this.hintText = `
                <b>Свободная</b> — это продажа объекта недвижимости за наличные деньги в одну сделку,
                в которой принимают участие только 1 продавец и 1 покупатель.<br/><br/>
                <b>Альтернативная</b> — единовременная сделка по продаже одного объекта недвижимости
                и приобретения другого.
            `;

    this.validation = validation(this.form, 'bargainTermsSaleType', {
      required: 'Укажите тип продажи',
    });

    this.handleChange = () => {
      const state = store.getState();
      const category = selectAnalyticsOfferStatus(state);

      trackRequiredFieldFill(category, 'sales_type');
    };
  },
  controllerAs: 'saleType',
  template,
})).name;
